import * as Yup from "yup";

export const idProof = [
  { value: "Aadhar", label: "Aadhar" },
  { value: "Pancard", label: "Pancard" },
  { value: "Driving License", label: "Driving License" },
];
export const addressProof = [
  { value: "Aadhar", label: "Aadhar" },
  // { value: "GST", label: "GST" },
  { value: "Voter ID", label: "Voter ID" },
  { value: "Passport", label: "Passport" },
];
export const Allqualification = [
  { value: "10th", label: "10th" },
  { value: "12th", label: "12th" },
  { value: "Diploma", label: "Diploma" },
  { value: "Graduation", label: "Graduation" },
  { value: "Post Graduation", label: "Post Graduation" },
  { value: "CA/CS/CMA Foundation", label: "CA/CS/CMA Foundation" },
  { value: "CA/CS/CMA Inter", label: "CA/CS/CMA Inter" },
  { value: "CA/CS/CMA Finalist", label: "CA/CS/CMA Finalist" },
  { value: "CA/CS/CMA", label: "CA/CS/CMA" },
];
export const usertype = [
  { value: "Seeker", label: "Seeker" },
  { value: "Auditor", label: "Auditor" },
];

export const validationSchema = Yup.object().shape({
  AuditorName: Yup.string().required("Name is required"),

  AuditorAge: Yup.date()
    .required("Date of Birth is required")
    .nullable()
    .max(new Date(), "Invalid Input"),
  AuditorGmail: Yup.string()
    .email("Invalid email")
    .required("Email is required"),
  AuditorContact: Yup.string()
    .required("Contact Number is required")
    // .matches(/^[0-9]{10}$/, "Invalid Contact Number"),
    .matches(/^[6-9]\d{9}$/, "Invalid Contact"),

  AuditorAddress: Yup.string().required("Address is required"),
  AuditorCountry: Yup.object().shape({
    value: Yup.string().required("Country is required"),
  }),
  gender: Yup.object().shape({
    value: Yup.string().required("Gender is required"),
  }),

  AuditorCity: Yup.object().shape({
    value: Yup.string().required("City is required"),
  }),
  AuditorState: Yup.object().shape({
    value: Yup.string().required("State is required"),
  }),
  AuditorPincode: Yup.string()
    .required("Pincode is required")
    .matches(/^[0-9]{6}$/, "Invalid Pincode"), // Ensure 6 digits
  WorkCity: Yup.array()
    .min(1, "Preference city is required")

    .of(
      Yup.object().shape({
        label: Yup.string().required("Enter work Preference city name"),
        value: Yup.string().required("Enter work Preference city name"),
      })
    ),
  AuditorQual: Yup.object().shape({
    value: Yup.string().required("Qualification is required"),
  }),
  TotalExperience: Yup.string().required("Total Experience is required"),
  ExperienceTrpw: Yup.string().notRequired(),
  WorkExperience: Yup.string().notRequired(),


  qualProofFile: Yup.string().required("Document is required"),
  AddressProofFile: Yup.string().required("Document is required"),
  AddressProof: Yup.object().shape({
    value: Yup.string().required("Address Proof is required"),
  }),
  // AddressProofNumber: Yup.string().when("AddressProof", {
  //     is: (AddressProof) => AddressProof?.value === "Aadhar",
  //     then: () =>
  //       Yup.string()
  //         .matches(/^\d{12}$/, "Aadhar number must be 12 digits")
  //         .required("Aadhar number is required"),
  //     otherwise: () =>
  //       Yup.string().when("AddressProof", {
  //         is: (AddressProof) => AddressProof?.value === "GST",
  //         then: () =>
  //           Yup.string()
  //             .matches(/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/, "Invalid GST Number")
  //             .required("GST number is required"),
  //       }),
  //   }),
  AddressProofNumber: Yup.string().when("AddressProof", {
    is: (AddressProof) => AddressProof?.value === "Aadhar",
    then: () =>
      Yup.string()
        .matches(/^\d{12}$/, "Aadhar number must be 12 digits")
        .required("Aadhar number is required"),
    otherwise: () =>
      Yup.string().when("AddressProof", {
        is: (AddressProof) => AddressProof?.value === "GST",
        then: () =>
          Yup.string()
            .matches(
              /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
              "Invalid GST Number"
            )
            .required("GST number is required"),
        otherwise: () =>
          Yup.string().when("AddressProof", {
            is: (AddressProof) => AddressProof?.value === "Voter ID",
            then: () =>
              Yup.string()
                // .matches(
                //   /^[A-Z]{3}[0-9]{7}$/,
                //   "Invalid Voter ID. Must follow format: 3 letters followed by 7 digits."
                // )
                .required("Voter ID is required"),
            otherwise: () =>
              Yup.string().when("AddressProof", {
                is: (AddressProof) => AddressProof?.value === "Passport",
                then: () =>
                  Yup.string()
                    .matches(
                      /^[A-Z]{1}[0-9]{7}$/,
                      "Invalid Passport Number. Must follow format: 1 letter followed by 7 digits."
                    )
                    .required("Passport number is required"),
              }),
          }),
      }),
  }),

  IdProofNumber: Yup.string().when("IDProof", {
    is: (IDProof) => IDProof?.value === "Aadhar",
    then: () =>
      Yup.string()
        .matches(/^\d{12}$/, "Aadhar number must be 12 digits")
        .required("Aadhar number is required"),
    otherwise: () =>
      Yup.string().when("IDProof", {
        is: (IDProof) => IDProof?.value === "Pancard",
        then: () =>
          Yup.string()
            .matches(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/, "Number is invalid")
            .required("Number is required"),
        otherwise: () =>
          Yup.string().when("IDProof", {
            is: (IDProof) => IDProof?.value === "Driving License",
            then: () =>
              Yup.string()
                // .matches(
                //     /^[A-Z]{2}[0-9]{13}$/,
                //     "Driving License number is invalid"
                // )
                .required("Driving License number is required"),
          }),
      }),
  }),


  IDProof: Yup.object().shape({
    value: Yup.string().required("ID proof is required"),
  }),

  identityProofFile: Yup.string().required("Document is required"),


  // resumeFile: Yup.string().required("Resume is required"),

  // SourceName: Yup.string().required("Source name is required"),
});
export const basicSchemaPartOne = Yup.object().shape({
  AuditorName: Yup.string().required("Name is required"),
  PhotoFile: Yup.string().required("Photo is required"),

  AuditorAge: Yup.date()
    .required("Date of Birth is required")
    .nullable()
    .max(new Date(), "Invalid Input"),
  AuditorGmail: Yup.string()
    .email("Invalid email")
    .required("Email is required"),

  AuditorContact: Yup.string()
    .required("Contact Number is required")
    .matches(/^[6-9]\d{9}$/, "Invalid Contact"),

  gender: Yup.object().shape({
    value: Yup.string().required("Gender is required"),
  }),
  AuditorQual: Yup.object().shape({
    value: Yup.string().required("Qualification is required"),
  }),

  // WorkCity: Yup.array()
  //   .min(1, "Preference city is required")
  //   .of(
  //     Yup.object().shape({
  //       label: Yup.string().required("Enter work Preference city name"),
  //       value: Yup.string().required("Enter work Preference city name"),
  //     })
  //   ),
});

export const basicSchemaPartTwo = Yup.object().shape({
  AuditorAddress: Yup.string().required("Address is required"),
  AuditorCountry: Yup.object().shape({
    value: Yup.string().required("Country is required"),
  }),
  AuditorState: Yup.object().shape({
    value: Yup.string().required("State is required"),
  }),
  AuditorCity: Yup.object().shape({
    value: Yup.string().required("City is required"),
  }),
  AuditorPincode: Yup.string()
    .required("Pincode is required")
    .matches(/^[0-9]{6}$/, "Invalid Pincode"), // Ensure 6 digits


});
export const gender = [
  { value: "Male", label: "Male" },
  { value: "Female", label: "Female" }
];